
import React, { useEffect, useState } from "react";

import {
  Container,
  Grid,
  IconButton,
  makeStyles,
  Typography,
  Paper,
  Button
} from "@material-ui/core";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import useDebounce from "../../../Components/debounce";
import DataService from "../../../Service";
import ManageTranchDetails from "./manageTranchDetails"

function TranchDetails() {
  const classes = useStyles();
  const [currentSelection, setCurrentSelection] = useState({});
  const [apiData, setApiData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [action, setAction] = useState(null);
  const [moduleSetups, setTranch] = useState([]);
  const [searchTextSelect, handleSearchText] = useState(null);
  const debouncedSearchText = useDebounce(searchTextSelect, 700);
  let urlElements = window.location.href.split('/');
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID
    }
    DataService.getDirectData(`/invoices/tranche_details`, params).then((response) => {

      let listData = response["client_invoices"]?.map((el)=>{
        const old={...el};
        if(old.status.toLowerCase()==="po to be raised"){
          old.status= "PO to be raised";
        }
        return old;
      });
      setApiData(listData);
      setTotalCount(response.total_count)
      setLoading(false);
    })

      .catch((err) => { });
  };
  const getSupplierData = () => {
    const params = {
      invoice_id: InvoiceID
    }
    DataService.getDirectData(`/invoices/tranche_details`, params).then((response) => {

      let supplierData = response["supplier_invoices"]?.map((el)=>{
        const old={...el};
        if(old.status.toLowerCase()==="po to be raised"){
          old.status= "PO to be raised";
        }
        return old;
      });
      console.log(supplierData,"supplier data")
      setSupplierData(supplierData);
      setTotalCount(response.total_count)
      setLoading(false);
    })

      .catch((err) => { });
  };
  useEffect(() => {
    setLoading(true);
    getData();
    getSupplierData()
  }, [page, pageSize, debouncedSearchText]);

  const statusMapButtons = { "Paid": "button-positive", "Invoice to be raised": "button-warning", "Near due": "button-negative", "Past due": "button-positive" }
  const columns = [
    {
      field: "tranches",
      title: "Tranches",
      headerStyle: { paddingLeft: 40 },
      cellStyle: { paddingLeft: 40, width: "14%" },
      render: (rowData) => {
        return (
          <p className={classes.tranchText}>
            {rowData.invoice_name} <span style={{ color: "#EF7000" }}>Invoice number: {rowData.invoice_number}</span>
          </p>
        );
      },
    },
    { field: "anticipated_invoice_date", title: "Anticipated Invoice date" },
    { field: "invoice_date", title: "Invoice date" },
    { field: "due_date", title: "Due date" },
    { field: "promised_date", title: "Promised date" },
    { field: "paid_date", title: "Paid date" },
    { field: "amount", title: "Tranche amount",
    render: (rowData) => (
      <div
        // className="center"
        // style={{ paddingLeft: "16px",display:"flex",gap:"1rem" }}
      >
      
        <span style={{textAlign:"left"}} >
          {rowData.amount}
        </span>
      </div>
    ),
  },
    {
      field: "tranche_amountranche_amount_gbp",
      title: "Tranche amount (in GBP)",
    },

    {
      field: "status",
      title: "Status",
      headerStyle: { paddingRight: 25 },
      cellStyle: { paddingRight: 25, width: "20%" },
      render: (rowData) => {
        return (
          <>
            <Button
              size="small"
              className={statusMapButtons[rowData.status]}
              // variant="outlined"
              style={{ textTransform: "initial" }}
            >
              <b>{rowData.status}</b>
            </Button>
            <IconButton
              onClick={() => {
                setCurrentSelection(rowData)
                setAction('edit')
              }}>
              <EditIcon />
            </IconButton>
          </>
        );
      },
    },
  ];

  const supplierColumns = [
    {
      field: "tranches",
      title: "Tranches",
      headerStyle: { paddingLeft: 40 },
      cellStyle: { paddingLeft: 40, width: "14%" },
      render: (rowData) => {
        return (
          <p className={classes.tranchText}>
            {rowData.invoice_name} <span style={{ color: "" }}>Invoice number: {rowData.invoice_number}</span>
          </p>
        );
      },
    },
    { field: "anticipated_invoice_date", title: "Anticipated invoice date" },
    { field: "invoice_date", title: "Invoice date" },
    { field: "due_date", title: "Due date" },
    { field: "promised_date", title: "Promised date" },
    { field: "paid_date", title: "Paid date" },
    { field: "amount", title: "Tranche amount",
    render: (rowData) => (
      <div
        // className="center"
        // style={{ paddingLeft: "16px",display:"flex",gap:"1rem" }}
      >
      
        <span style={{textAlign:"left"}} >
          {rowData.amount}
        </span>
      </div>
    ),
  },
    {
      field: "tranche_amountranche_amount_gbp",
      title: "Tranche amount (in GBP)",
    },

    {
      field: "status",
      title: "Status",
      headerStyle: { paddingRight: 25 },
      cellStyle: { paddingRight: 25, width: "20%" },
      render: (rowData) => {
        return (
          <>
            <Button
              size="small"
              className={statusMapButtons[rowData.status]}
              // variant="outlined"
              style={{ textTransform: 'none' }}
            >
              <b>{rowData.status}</b>
            </Button>
            <IconButton
              onClick={() => {
                setCurrentSelection(rowData)
                setAction('edit')
              }}>
              <EditIcon />
            </IconButton>
          </>
        );
      },
    },
  ];
  const handleClose = (data, id) => {
    let moduleList = [];

    // const newList = { ...data, data: [newData].concat(data.data) };
    // TableAction.addDataToList(dispatch, dataDispatch, newList);
    if (action === 'create' && data && data.id) {
      // moduleList = { ...moduleSetups, moduleSetups: [data].concat(data.data) }
      moduleList = [data].concat(moduleSetups);
      setTranch(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map(base => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      })
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter(base => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  }
  const options = {
    headerStyle: { textAlign: "left", fontWeight: "bold", fontSize: 14 },
    cellStyle: { textAlign: "left", fontSize: 14 },
    actionsColumnIndex: -1,
    toolbar: false,
    search: false,
    sorting: false,
    showTitle: false,
    draggable: false,
    paging: false,
  };

  return (
    <div>
      <Container>
        {/* <Paper style={{ boxShadow: "0px 3px 5px #232323", border: "none" }}> */}
        <Grid container>
          <Typography className={classes.title} variant="body1">
            Client tranche details
          </Typography>
        </Grid>

        <Grid container>
          <Grid item xs={12}>
            <MaterialTable
              // style={{ width: "100%", boxShadow: "0px 3px 10px #232323" }}
              options={options}
              columns={columns}
              data={apiData}
              onRowClick={(e, rowData) => {
                setCurrentSelection(rowData);
              }}
              onMouseEnter={(e) => console.log(e)}
            />
          </Grid>
        </Grid>

        <Grid container style={{ marginTop: 40 }}>
          <Typography className={classes.title} variant="body1">
            Supplier tranche details
          </Typography>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <MaterialTable
              // style={{ width: "100%",  }}
              options={options}
              columns={supplierColumns}
              data={supplierData}
              onRowClick={(e, rowData) => {
                setCurrentSelection(rowData);
              }}
              onMouseEnter={(e) => console.log(e)}
            />
          </Grid>
        </Grid>
        {/* </Paper> */}
      </Container>
      {action && <ManageTranchDetails InvoiceID={InvoiceID} action={action} moduleId={currentSelection.id} getData={getData}
        data={currentSelection} handleClose={handleClose} getSupplierData={getSupplierData} />}
    </div>
  );
}

export default TranchDetails;



const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#EF7000",
    marginLeft: 2,
    marginBottom: 36,
  },

  tranchText: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#232323",
    display: "flex",
    flexDirection: "column",
    "& > span": {
      fontSize: 12,
      color: "#EF7000",
      marginTop: 7,
      fontWeight: "normal",
    },
  },
}));
